if ($('#menu-card-overview')) {
    require('./menu/overview');
}

let sidebar = $('#nav-sidebar');

if (sidebar.length) {
    sidebar.find('[data-toggle="nav-dropdown"]').each(function () {
        $(this).click((e) => {
            $(this.dataset.target).slideToggle(200);
        })
    });

    sidebar[0].querySelectorAll('#toggle-nav-sidebar')[0]
        .addEventListener('click', function () {
            sidebar.toggleClass('icon-view');

            if (sidebar.hasClass('icon-view')) {
                document.cookie = 'nav-bar-toggle=1;SameSite=lax; path=/';
                return;
            }
            document.cookie = 'nav-bar-toggle=0;SameSite=lax; path=/';
        })

    sidebar.find('.nav > .nav-item').on('hover', function () {
        let item = $(this);
        let title = item.find('span.nav-hide').text();

        if (item.find('button.dropdown-toggle').length) {

        }

    })

    $('#nav-sidebar-toggle').click(function () {
        sidebar.slideToggle('fast');
        $(this).find('i').toggleClass('fa-bars').toggleClass('fa-times')
    });
}

/* Check control key press. */
var ctrlPressed = false;
$(document).keydown(function (e) {
    if (e.ctrlKey) {
        ctrlPressed = true;
    }
}).keyup(function (e) {
    if (e.ctrlKey) {
        ctrlPressed = false;
    }
});

/* Open/close menu on Ctrl-m key press. */
$(document).keydown(function (e) {
    if (ctrlPressed && e.which === 77) {
        e.preventDefault();
        $('#toggle-nav-sidebar').click();
        if (sidebar.hasClass('icon-view')) {
            document.cookie = 'nav-bar-toggle=1;SameSite=lax; path=/';
            return;
        }
        document.cookie = 'nav-bar-toggle=0;SameSite=lax; path=/';
        ctrlPressed = false;
    }
})

// whenever we hover over a menu item that has a submenu
$('ul#navigation-sidebar > li').on('mouseover', function () {
    let $menuItem = $(this), $submenuWrapper = $('> .nav-icons-submenu', $menuItem);

    // grab the menu item's position relative to its positioned parent
    let menuItemPos = $menuItem.position();

    // place the submenu in the correct position relevant to the menu item
    $submenuWrapper.css({
        top: menuItemPos.top,
        left: menuItemPos.left + $menuItem.outerWidth()
    });
});

